import { useSelector } from 'react-redux';

/**
 * Only to be used when unsure if workspace level app has been mounted
 */
export const useUnsafeCurrentWorkspaceId = () => {
  // FIXME: using the redux state here will create a dependency loop
  return useSelector((state: Record<string, any>) => state.ui.currentWorkspaceId);
};

export const useCurrentWorkspaceId = () => {
  const workspaceId = useUnsafeCurrentWorkspaceId();
  if (!workspaceId) {
    throw new Error('used workspace id outside workspace');
  }
  return workspaceId;
};
